import React from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {maybeGetUnitFromCacheBySymbol} from 'inventory/InventoryUnitUtil';
import {FILTER_PREDICATES_BY_MEASUREMENT_TYPE, MeasurementType} from 'samples/MeasurementForm';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {SelectDropdownErrorStyle} from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import {UnitTypesQuery} from 'units/__generated/UnitTypesQuery';
import {PresentationalSearchableUnitDropdown} from 'units/SearchableUnitDropdown';
import {UNIT_TYPES_QUERY} from 'units/UnitsConstants';

export interface MeasurementUnitFormProps {
  dataTestAttrs?: DataTestAttrs;
  disabled?: boolean;
  isInline?: boolean;
  label: string;
  measurementType: MeasurementType;
  onUpdate: (value?: string) => void;
  value?: string;
}

export default function MeasurementUnitForm(props: MeasurementUnitFormProps): JSX.Element {
  return (
    <BenchlingQuery<UnitTypesQuery>
      query={UNIT_TYPES_QUERY}
      renderLoading={BenchlingQuery.DEFAULT_RENDER_LOADING}
    >
      {({unitTypes}) => {
        const unit = props.value ? maybeGetUnitFromCacheBySymbol(props.value) : null;
        return (
          <div>
            {!props.isInline ? (
              <FieldLabel label={props.label} labelStyle={LabelStyle.LABEL} isRequired={true} />
            ) : null}
            <PresentationalSearchableUnitDropdown
              displaySelectionAsSymbol={true}
              disabled={props.disabled}
              onSelect={(unit) => {
                props.onUpdate(unit?.symbol);
              }}
              selectedId={unit?.id}
              unitTypeFilter={FILTER_PREDICATES_BY_MEASUREMENT_TYPE[props.measurementType]}
              unitTypes={unitTypes}
              {...getTestProps(props.dataTestAttrs)}
              {...(props.value && !unit
                ? {
                    customPlaceholder: props.value,
                    icon: 'warning',
                    error: `${props.value} is not a valid unit.`,
                    errorStyle: SelectDropdownErrorStyle.TOOLTIP,
                  }
                : {})}
            />
          </div>
        );
      }}
    </BenchlingQuery>
  );
}
